import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=38b5e1ee&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"
import style0 from "./tableList.vue?vue&type=style&index=0&id=38b5e1ee&prod&scoped=true&lang=scss"
import style1 from "./tableList.vue?vue&type=style&index=1&id=38b5e1ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5e1ee",
  null
  
)

export default component.exports